/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculateHashResponse
 */
export interface CalculateHashResponse {
    /**
     * 
     * @type {string}
     * @memberof CalculateHashResponse
     */
    hash?: string;
}

/**
 * Check if a given object implements the CalculateHashResponse interface.
 */
export function instanceOfCalculateHashResponse(value: object): boolean {
    return true;
}

export function CalculateHashResponseFromJSON(json: any): CalculateHashResponse {
    return CalculateHashResponseFromJSONTyped(json, false);
}

export function CalculateHashResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculateHashResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hash': json['hash'] == null ? undefined : json['hash'],
    };
}

export function CalculateHashResponseToJSON(value?: CalculateHashResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hash': value['hash'],
    };
}

